"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnnotationTooltipVisibleSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var get_annotation_tooltip_state_1 = require("./get_annotation_tooltip_state");
exports.isAnnotationTooltipVisibleSelector = re_reselect_1.default([get_annotation_tooltip_state_1.getAnnotationTooltipStateSelector], function (annotationTooltipState) { return annotationTooltipState !== null && annotationTooltipState.isVisible; })(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=is_annotation_tooltip_visible.js.map